import { Injectable, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { filter } from 'rxjs/operators';

interface SwipeGuardPlugin {
  setGuarded(options: { guarded: boolean }): Promise<void>;
  addListener(
    event: 'guardedSwipeBack',
    callback: () => void,
  ): Promise<{ remove: () => void }>;
}

const SwipeGuard = registerPlugin<SwipeGuardPlugin>('SwipeGuard');

@Injectable({
  providedIn: 'root',
})
export class SwipeGuardService {
  private readonly isIosNative: boolean =
    Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly ngZone: NgZone,
  ) {}

  public init(): void {
    if (!this.isIosNative) {
      return;
    }

    SwipeGuard.addListener('guardedSwipeBack', () => {
      this.ngZone.run(() => this.location.back());
    });

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const guarded = this.hasCanDeactivate();
        SwipeGuard.setGuarded({ guarded }).catch(() => {});
      });
  }

  private hasCanDeactivate(): boolean {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return (route.routeConfig?.canDeactivate?.length ?? 0) > 0;
  }
}
